import { clearPersonalNumber } from './clearPersonalNumber';

export const validatePersonalNumber = (input?: string): boolean =>
  !!clearPersonalNumber(input);
